import React from 'react';
import { Card, Row, Col, Spin, Empty, Progress } from 'antd';

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatPercent = (value) => `${toNumber(value).toFixed(1)}%`;

const InadimplenciaUnidadesChartV2 = ({ data, loading }) => {
  if (loading) {
    return (
      <Card title="Inadimplencia por Unidade" style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
          <Spin size="large" tip="Carregando inadimplencia..." />
        </div>
      </Card>
    );
  }

  const listaBase = Array.isArray(data?.inadimplencia_por_unidade)
    ? data.inadimplencia_por_unidade
    : [];

  if (!listaBase.length) {
    return (
      <Card title="Inadimplencia por Unidade" style={{ marginBottom: '24px' }}>
        <Empty description="Sem dados de inadimplencia por unidade" />
      </Card>
    );
  }

  const listaNormalizada = [...listaBase]
    .map((item) => ({
      unidade: item?.unidade || '-',
      taxa: toNumber(item?.taxa),
    }));

  const ranking = [...listaNormalizada]
    .sort((a, b) => b.taxa - a.taxa)
    .slice(0, 6);

  const media = listaNormalizada.length
    ? listaNormalizada.reduce((acc, item) => acc + item.taxa, 0) / listaNormalizada.length
    : 0;

  return (
    <Card title="Inadimplencia por Unidade" style={{ marginBottom: '24px' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card size="small">
            <div style={{ fontSize: 12, color: '#666' }}>Inadimplencia Media</div>
            <div style={{ fontSize: 28, fontWeight: 600, color: '#cf1322', lineHeight: 1.2 }}>
              {formatPercent(media)}
            </div>
          </Card>
        </Col>

        <Col xs={24}>
          <div style={{ display: 'grid', gap: 12 }}>
            {ranking.map((item, index) => {
              const progressPercent = Math.max(0, Math.min(item.taxa, 100));

              return (
                <div key={`${item.unidade}-${index}`}>
                  <Row justify="space-between" style={{ marginBottom: 4 }}>
                    <Col style={{ fontWeight: 500 }}>{item.unidade}</Col>
                    <Col style={{ color: '#cf1322', fontWeight: 600 }}>
                      {formatPercent(item.taxa)}
                    </Col>
                  </Row>
                  <Progress
                    percent={progressPercent}
                    showInfo={false}
                    strokeColor="#cf1322"
                    trailColor="#f5f5f5"
                  />
                </div>
              );
            })}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default InadimplenciaUnidadesChartV2;
